var mzg;
if (!mzg) {
    mzg = {};
}

$.extend(mzg,
    /**
     * @lends mzg
     */
    {
        /**
         * @namespace
         * @description slider
         */
        slider_oneSlide: {
            _obj: null,
            _selector: '.slider--oneSlide .swiper-container',
            _config: {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 20,
                preloadImages: true,
                lazy: true,
                autoplay: {
                    delay: 7500,
                    waitForTransition: true
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            },
            
            /**
             * @type {function}
             * @description initialize News Slider
             */
            init: function () {               
                mzg.newsSlider._obj = new Swiper(mzg.slider_oneSlide._selector, mzg.slider_oneSlide._config);
            }
        }
    }
);

$(mzg.slider_oneSlide.init);
